/**
 * Enum representing record states for a quote being updated.
 */
export enum RecordState {
    New = 1,
    Deleted = 2,
    Unchanged = 3,
    Edited = 4
}